(function() {
  // Protection contre le chargement multiple
  if (window.bundleQuantityInitialized) return;
  window.bundleQuantityInitialized = true;

  function init() {
    const bundleContainer = document.querySelector('[data-bundle-container]');
    if (!bundleContainer) return;

    // Fonction pour obtenir la quantité maximale depuis le quantity selector principal
    function getMaxBundleQuantity() {
      // Chercher le quantity selector principal du produit
      const mainQuantityInput = document.querySelector('input[name="quantity"]');
      if (mainQuantityInput) {
        const quantity = parseInt(mainQuantityInput.value) || 1;
        // Si la quantité est 4 ou plus, pas de limite (retourner 999)
        if (quantity >= 4) {
          return 999;
        }
        return quantity;
      }
      return 1; // Par défaut 1 si pas trouvé
    }

    // Fonction pour calculer le total actuel du bundle
    function getCurrentBundleTotal() {
      const allInputs = bundleContainer.querySelectorAll('[data-quantity-input]');
      let total = 0;
      allInputs.forEach(function(input) {
        total += parseInt(input.value) || 0;
      });
      return total;
    }

    // Fonction pour mettre à jour l'état du bouton moins
    function updateMinusButton(minusBtn, value) {
      if (value > 0) {
        minusBtn.classList.add('active');
      } else {
        minusBtn.classList.remove('active');
      }
    }

    // Fonction pour mettre à jour l'état de tous les boutons plus
    function updateAllPlusButtons() {
      const maxQuantity = getMaxBundleQuantity();
      const currentTotal = getCurrentBundleTotal();
      const bundleItems = bundleContainer.querySelectorAll('[data-bundle-item]');
      
      bundleItems.forEach(function(item) {
        const plusBtn = item.querySelector('[data-quantity-plus]');
        if (plusBtn) {
          if (currentTotal >= maxQuantity) {
            plusBtn.disabled = true;
            plusBtn.style.opacity = '0.3';
            plusBtn.style.cursor = 'not-allowed';
          } else {
            plusBtn.disabled = false;
            plusBtn.style.opacity = '1';
            plusBtn.style.cursor = 'pointer';
          }
        }
      });
    }

    // Attacher les événements à chaque item individuellement
    const bundleItems = bundleContainer.querySelectorAll('[data-bundle-item]');
    
    bundleItems.forEach(function(item) {
      const input = item.querySelector('[data-quantity-input]');
      const minusBtn = item.querySelector('[data-quantity-minus]');
      const plusBtn = item.querySelector('[data-quantity-plus]');
      
      if (!input || !minusBtn || !plusBtn) return;
      
      // Initialiser l'état du bouton moins
      updateMinusButton(minusBtn, parseInt(input.value) || 0);
      
      // Event listener pour le bouton MOINS
      minusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const currentValue = parseInt(input.value) || 0;
        if (currentValue > 0) {
          const newValue = currentValue - 1;
          input.value = newValue;
          updateMinusButton(minusBtn, newValue);
          updateAllPlusButtons();
        }
      }, { once: false });
      
      // Event listener pour le bouton PLUS
      plusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const maxQuantity = getMaxBundleQuantity();
        const currentTotal = getCurrentBundleTotal();
        const currentValue = parseInt(input.value) || 0;
        const maxValue = parseInt(input.getAttribute('max')) || 99;
        
        // Vérifier si on peut encore ajouter
        if (currentTotal < maxQuantity && currentValue < maxValue) {
          const newValue = currentValue + 1;
          input.value = newValue;
          updateMinusButton(minusBtn, newValue);
          updateAllPlusButtons();
        }
      }, { once: false });
    });

    // Fonction pour ajuster le bundle quand la quantité max diminue
    function adjustBundleToLimit() {
      const maxQuantity = getMaxBundleQuantity();
      let currentTotal = getCurrentBundleTotal();
      
      // Si le total dépasse la limite, retirer des produits du bas vers le haut
      if (currentTotal > maxQuantity) {
        const bundleItems = Array.from(bundleContainer.querySelectorAll('[data-bundle-item]'));
        
        // Parcourir du bas vers le haut (reverse)
        for (let i = bundleItems.length - 1; i >= 0 && currentTotal > maxQuantity; i--) {
          const item = bundleItems[i];
          const input = item.querySelector('[data-quantity-input]');
          const minusBtn = item.querySelector('[data-quantity-minus]');
          
          if (input) {
            const currentValue = parseInt(input.value) || 0;
            
            // Calculer combien il faut retirer
            const toRemove = Math.min(currentValue, currentTotal - maxQuantity);
            
            if (toRemove > 0) {
              const newValue = currentValue - toRemove;
              input.value = newValue;
              updateMinusButton(minusBtn, newValue);
              currentTotal -= toRemove;
            }
          }
        }
      }
      
      updateAllPlusButtons();
    }

    // Initialiser l'état au chargement
    adjustBundleToLimit();

    // Observer les changements du quantity selector principal
    const mainQuantityInput = document.querySelector('input[name="quantity"]');
    if (mainQuantityInput) {
      // Observer les changements directs
      mainQuantityInput.addEventListener('change', function() {
        adjustBundleToLimit();
      });
      
      // Observer avec MutationObserver pour les changements via JS
      const observer = new MutationObserver(function() {
        adjustBundleToLimit();
      });
      observer.observe(mainQuantityInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();